import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function actionCardAction(theme: Theme): ComponentStyle {
  return {
    componentName: 'actionCardAction',
    variants: {
      orange: {
        backgroundColor: theme.colors.spark.orange5,
        color: theme.colors.spark.black
      }
    }
  };
}
